/* eslint-disable react/forbid-dom-props */
import React from 'react'

export const MagicLinkIcon = () => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="148" height="147">
    <defs>
      <filter
        id="magiclink_a"
        width="275%"
        height="275%"
        x="-87.5%"
        y="-87.5%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="10" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="15"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0.996078431 0 0 0 0 0.505882353 0 0 0 0 0.180392157 0 0 0 0.183948864 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter
        id="magiclink_e"
        width="116.7%"
        height="116.7%"
        x="-8.3%"
        y="-8.3%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation="3"
        />
        <feOffset
          dx="-2"
          dy="-1"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 1 0 0 0 0 0.876656309 0 0 0 0 0.562690549 0 0 0 0.748333698 0"
        />
      </filter>
      <path
        id="magiclink_b"
        d="M37.12.327L1.05 21.137c-1.408.809-1.229 2.77.172 3.361l8.272 3.47L31.852 8.266c.428-.382 1.035.202.67.646L13.773 31.75v6.265c0 1.836 2.218 2.56 3.308 1.23l4.941-6.016 9.697 4.062a1.873 1.873 0 002.568-1.417L39.89 2.257c.265-1.572-1.424-2.708-2.77-1.93z"
      />
      <path id="magiclink_d" d="M-4-4h48v48H-4z" />
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      filter="url(#magiclink_a)"
      transform="translate(30 20)"
    >
      <rect width="87.609" height="87.609" fill="#E68027" rx="29.203" />
      <g transform="translate(21 24)">
        <mask id="magiclink_c" fill="#fff">
          <use xlinkHref="#magiclink_b" />
        </mask>
        <g mask="url(#magiclink_c)">
          <use fill="#FFF" xlinkHref="#magiclink_d" />
          <use
            fill="#000"
            filter="url(#magiclink_e)"
            xlinkHref="#magiclink_d"
          />
        </g>
      </g>
    </g>
  </svg>
)
